module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.Connect3-400e38527300ef43db469e5915ce3678.jpg";